import React, { useState } from "react";
import Modal from "react-modal";
import { convertStraight, convertThenFormat } from "../../common-data/Converts";
import { returnAccurate } from "./GenericFunctions";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";

const DetailListings = ({ row }) => {
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const isPassbook = row?.passbook && row?.passbook !== "null";
  const is12thMarksheet = row?.marksheet12 && row?.marksheet12 !== "null";
  const is10thMarksheet = row?.marksheet10 && row?.marksheet10 !== "null";
  const isPanCard = row?.pan_card && row?.pan_card !== "null";
  const isIDProof = row?.id_card && row?.id_card !== "null";
  const isPhoto = row?.photo && row?.photo !== "null";

  const isTrainer_FD =
    row?.account_type === "trainer" || row?.account_type === "receptionist";
  const isTrainer = row?.account_type === "trainer";

  const formatTime = (time) => {
    if (!time) return null;
    let [hours, minutes] = time.split(":").map(Number);
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  function onCloseModal() {
    setModValues(iniModValues);
  }

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "staff_photo" ? "modal-container-abs" : ""
          }`}
        >
          <ModalHeadAndClose
            title={
              modValues.cardName === "staff_photo"
                ? modValues.rowData?.name
                : modValues.cardName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.cardName === "staff_photo" ? (
            <div className="discussionModalMessage mt30">
              <img src={modValues.image} alt={modValues.rowData?.name} />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          {isTrainer_FD && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Shift Details</p>
              </div>
              <div className="user-details-info">
                {row.shift_details &&
                Array.isArray(row.shift_details) &&
                row.shift_details.length > 0 ? (
                  row.shift_details.map((shift, index) => (
                    <p className="info-name" key={index}>
                      {formatTime(shift.shift_start)} -{" "}
                      {formatTime(shift.shift_end)}
                    </p>
                  ))
                ) : (
                  <p className="info-name">No Shift Assigned</p>
                )}
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">salary</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                ₹{convertThenFormat(row?.salary || 0)}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Emergency Contact</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.emergency_contact || "NA"}</p>
            </div>
          </div>

          {isTrainer && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">expertise</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">{row?.expertise || "NA"}</p>
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">DOB</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.dob ? convertStraight(row.dob) : "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Reonboarding Date</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.reonboarding_date
                  ? convertStraight(row.reonboarding_date)
                  : "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Reonboarded By</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.reonboarded_by_name || "NA"}
                <br />
                <small className="lowercase">
                  {row?.reonboarded_by_mobile || ""}
                  <br />
                  {row?.reonboarded_by_email || ""}
                </small>
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">address</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.address || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">PIN Code</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.postal_code || "-"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">bank name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.bank_name || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">bank account number</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.account_number || "-"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">IFSC Code</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.ifsc_code || "-"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">UPI ID</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.upi_id || "-"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">PAN card</p>
            </div>
            <div className="user-details-info">
              {returnAccurate(isPanCard, row?.pan_card, row, setModValues)}
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">ID Proof</p>
            </div>
            <div className="user-details-info">
              {returnAccurate(isIDProof, row.id_card, row, setModValues)}
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">passbook/ checkbook</p>
            </div>
            <div className="user-details-info">
              {returnAccurate(isPassbook, row.passbook, row, setModValues)}
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">12th marksheet</p>
            </div>
            <div className="user-details-info">
              {returnAccurate(
                is12thMarksheet,
                row.marksheet12,
                row,
                setModValues
              )}
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">10th marksheet</p>
            </div>
            <div className="user-details-info">
              {returnAccurate(
                is10thMarksheet,
                row.marksheet10,
                row,
                setModValues
              )}
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">staff photo</p>
            </div>
            <div className="user-details-info">
              {returnAccurate(isPhoto, row.photo, row, setModValues)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailListings;
